<template>
    <div class="xqNews_detail">
      <!-- 新区要闻详情 -->
      <!-- 内容区 -->
      <div class="content">
        <div class="infoCon inner">
            <iframe style="width:100%;height:80vh" src="http://121.17.167.168:49001/chat/share?shared_id=80a21690093b11f09dc50242ac1b0006&from=chat&auth=JmYmU3NTJlMDkzZDExZjBiNjUzMDI0Mm" ></iframe>
        </div>
        
      </div>
      <!-- footer -->
      <!-- <index-footer></index-footer> -->
    </div>
  </template>
  
  <script>
  // import indexTop from "./../components/top";
  // import indexFooter from "./../components/footer";
  export default {
    data() {
      return {
        articleTitle: "",
        navList: [],
        nowIndex: null,
        // nowId: null,
        // nowName: null,
        catelist: [],
        content: "", //富文本
        articledetail: {
          article_info: {
            title: "",
            publish_at: "",
            admin: {}
          },
          last_article: {}, //上一篇
          next_article: {} //下一篇
        }
      };
    },
    created() {
    //   this.getArticledetail();
      this.getNav();
      // this.wxShare();
    },
    // components: {
    //   indexTop,
    //   indexFooter
    // },
    // beforeRouteEnter(to, from, next) {
    //   //  修复iOS版微信HTML5 History兼容性问题
    //   // console.log("to.path",to.path);
      // console.log("location.pathname",location);
      // console.log("to",to);
    //   if (to.path !== location.pathname) {
    //     // 此处不可使用location.replace
    //     location.assign(to.fullPath);
    //   } else {
        // next();
    //   }
    // },
    methods: {
       // 图片拼接地址
      adddom(src) {
        if (src == "" || src == undefined || src == null) {
          console.log("src地址有问题");
          return "";
        }
        if (src.substr(0, 4).toLowerCase() === "http") {
          return src;
        }
        return this.$url + src;
      },
      wxShare() {
        var that = this;
        // console.log("分享内");
        // { url: shareUrl }
        const shareUrl = location.href.split("#")[0];
        // const shareUrl = location.href;
        // console.log("location.href",location.href);
        // console.log("shareUrl",shareUrl);
        that.$api.common.commonShare({ url: shareUrl }).then(res => {
          if (res.code == 200) {
            that.shareConfig = res.result;
            // console.log(that.shareConfig);
            wx.config({
              debug: that.shareConfig.debug,
              beta: that.shareConfig.beta,
              jsApiList: that.shareConfig.jsApiList,
              appId: that.shareConfig.appId,
              nonceStr: that.shareConfig.nonceStr, // 随机串
              timestamp: parseInt(that.shareConfig.timestamp), // 时间戳
              signature: that.shareConfig.signature // 签名
            });
            // console.log('Iframe ---微信分享设置---开始');
            // 分享
            wx.ready(function() {
              var shareDataA = {
                title: that.articledetail.article_info
                  ? that.articledetail.article_info.title
                  : "河北衡水高新技术产业开发区管理管委会", // 分享标题
                desc: "河北衡水高新技术产业开发区管理管委会", // 分享描述
                link: location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                imgUrl: "http://www.hskfq.gov.cn/statics/image/wxshare.jpg", // 分享图标
                success: function() {},
                cancel: function(e) {}
              };
              var shareDataB = {
                title: that.articledetail.article_info
                  ? that.articledetail.article_info.title
                  : "河北衡水高新技术产业开发区管理管委会", // 分享标题
                link: location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                imgUrl: "http://www.hskfq.gov.cn/statics/image/wxshare.jpg", // 分享图标
                success: function() {},
                cancel: function(e) {}
              };
              // wx.onMenuShareAppMessage(shareDataA); //微信内分享
              wx.updateAppMessageShareData(shareDataA); // 分享给朋友
              wx.updateTimelineShareData(shareDataB); // 分享到朋友圈
              // console.log('Iframe ---微信分享设置---结束');
            });
          }
        });
      },
      getfu(str) {
        var res = str.split(",");
        var fu = [];
        for (var i in res) {
          fu.push(res[i]);
        }
        // this.fuList = res;
      },
      goback() {
        // this.$router.go(-1);
        // this.$router.push({
        //   path: "xqNews",
        //   query: {
        //     id: this.catelist[this.nowIndex].id,
        //     index: this.nowIndex
        //   }
        // });
      },
      getNav() {
        var that = this;
        that.nowIndex = that.$route.query.index;
        // that.nowId = that.$route.query.erId;
        that.$api.index.catelist({}).then(function(res) {
          if (res.code == 200) {
            that.catelist = res.result.all_cate;
  
            // var s_cates = that.catelist[that.nowIndex].s_cates;
            // for (var i in s_cates) {
            //   if (s_cates[i].id == that.nowId) {
            //     that.nowName = s_cates[i].title;
            //   }
            // }
          }
        });
      },
      
      
    },
    mounted() {},
    watch: {
      $route(to, from) {
        // this.getArticledetail();
      }
    }
  };
  </script>
  
  <style>
  .fwb table {
    float: none;
  }
  </style>